import React from 'react';
import type { WorkoutPlanPayload } from '../../../../data-access/api/science/openapi/api';
import '../richContext.scss';

type WorkoutPlanExercise = NonNullable<WorkoutPlanPayload['exercises']>[number];

type Props = {
  exercises: WorkoutPlanExercise[];
};

const CardioWorkoutPlanContent: React.FC<Props> = ({ exercises }) => {
  const cardioPlans = exercises.filter((ex) => (ex as any)?.type === 'cardio_plan');
  if (cardioPlans.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {cardioPlans.map((ex, idx) => {
        const description =
          typeof (ex as any).description === 'string' && String((ex as any).description).trim()
            ? String((ex as any).description).trim()
            : 'Cardio plan';
        const segments: Record<string, unknown>[] = Array.isArray((ex as any).segments)
          ? (((ex as any).segments as unknown[]) as Record<string, unknown>[])
          : [];

        return (
          <div key={`cardio_${idx}`} style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <div className="rc-workout-exercise-row">
              <div className="rc-workout-exercise-left">
                <div style={{ flex: 1, minWidth: 0 }}>
                  <span className="rc-workout-exercise-name">{description}</span>
                </div>
              </div>
            </div>

            {segments.length > 0 && (
              <div className="rc-workout-segment-list">
                {segments.slice(0, 8).map((seg, segIdx, arr) => {
                  const type =
                    typeof seg.type === 'string' && seg.type.trim() ? seg.type.trim() : null;
                  const durationMin =
                    typeof seg.duration_min === 'number' && Number.isFinite(seg.duration_min)
                      ? Math.max(0, Math.round(seg.duration_min as number))
                      : null;
                  const pace =
                    typeof seg.pace === 'string' && seg.pace.trim() ? seg.pace.trim() : null;

                  if (!type && durationMin == null && !pace) return null;

                  const showPace = !!pace && pace.toUpperCase() !== 'NA';
                  const durationText = durationMin != null ? `${durationMin}m` : '—';
                  const typeText = type ?? 'Segment';
                  const text = `${durationText}: ${typeText}${showPace ? ` (${pace})` : ''}`;
                  const isLast = segIdx === arr.length - 1;

                  return (
                    <div key={`seg_${segIdx}`} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      <div className="rc-workout-segment-row">
                        <div className="rc-workout-segment-duration-pill">
                          <span className="rc-workout-segment-duration-text">{durationText}</span>
                        </div>
                        <div className="rc-workout-segment-text-wrap">
                          <span className="rc-workout-segment-text">{text}</span>
                        </div>
                      </div>
                      {!isLast && (
                        <div className="rc-workout-segment-connector">
                          <span className="rc-workout-segment-connector-text">↓</span>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CardioWorkoutPlanContent;
